var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.7904V8.1237C5 7.41645 5.28095 6.73818 5.78105 6.23808C6.28115 5.73798 6.95942 5.45703 7.66667 5.45703H10.3333M21.6667 5.45703H24.3333C25.0406 5.45703 25.7189 5.73798 26.219 6.23808C26.719 6.73818 27 7.41645 27 8.1237V10.7904M27 22.1237V24.7904C27 25.4976 26.719 26.1759 26.219 26.676C25.7189 27.1761 25.0406 27.457 24.3333 27.457H21.6667M10.3333 27.457H7.66667C6.95942 27.457 6.28115 27.1761 5.78105 26.676C5.28095 26.1759 5 25.4976 5 24.7904V22.1237M21.3333 21.7904L18.8 19.257M20 16.457C20 18.6662 18.2091 20.457 16 20.457C13.7909 20.457 12 18.6662 12 16.457C12 14.2479 13.7909 12.457 16 12.457C18.2091 12.457 20 14.2479 20 16.457Z",
    stroke: "#43B5F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifyingGlass);
export default __webpack_public_path__ + "static/media/icon_magnifying-glass.80d2b1e3d69418dcca304ad80635a98a.svg";
export { ForwardRef as ReactComponent };